import React, { useState, useEffect, useRef } from 'react';
import '../Nosotros/Nosotros.css';
import img1 from '../../img/Nosotros/Fondo/1.jpg';
import img2 from '../../img/Nosotros/Fondo/2.png';
import img3 from '../../img/Nosotros/Fondo/3.jpg';
import img4 from '../../img/Inicio/Fondo/4.JPG';
import logo from '../../img/Logo/tmologo.png';
import recubri from '../../img/Inicio/Servicios/recubrimiento.JPG';
import { useNavigate, Link } from "react-router-dom";
import esr from '../../img/Certificaciones/Empresasocialmenteresponsable.png';
import vidnosotros from '../../img/Nosotros/Seguridad TMO.mp4';
import roseta from '../../img/Nosotros/Fondo/Roseta gift.gif'
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import aviso from '../doc/Aviso de Privacidad TMO.pdf'
import termino from '../doc/Terminos y Condiciones TMO.pdf'

const fondoSecuencial = [img1, img3,];

const Nosotros = () => {
    const [imageToShow, setImageToShow] = useState(img1);
    const [esAniversario, setEsAniversario] = useState(false);

    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.volume = 0.0;
        }
    }, []);

    // Efecto Fondo 
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const index = Math.min(
                fondoSecuencial.length - 1,
                Math.floor(scrollTop / 500)
            );
            setImageToShow(fondoSecuencial[index]);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Aniversario
    useEffect(() => {
        const hoy = new Date();
        if (hoy.getDate() === 11 && hoy.getMonth() === 10) {
            setEsAniversario(true);
        }
    }, []);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000); // puedes cambiar el tiempo si lo deseas
        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <div className="preloader">
                <img src={roseta} loading="lazy" alt="Cargando..." className="gif-preloader" />
            </div>
        );
    }

    return (
        <div className="inicio-container">
            {esAniversario && (
                <div className="fireworks-background" />
            )}

            <div className="fondo-global-nosotros" style={{ backgroundImage: `url(${imageToShow})` }}>
                <div className="capa-negra" />
            </div>

            <div className="barra-superior-completa">
                <div className="barra-superior">
                    <div className="horario-contacto">
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="#fbd301" className="bi bi-circle-fill" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg> Lun-Vie: 8:00 - 17:00</span>
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="#fbd301" className="bi bi-circle-fill" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg> 55 8854 5539</span>
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="#fbd301" className="bi bi-circle-fill" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg> contacto@troqueladosmodulares.com.mx</span>
                    </div>
                </div>

                <div className="barra-logo-iconos">
                    <div className="logo-superior">
                        <Link to={'/'}>
                        <img src={logo} loading="lazy" alt="Logo" />
                        </Link>
                    </div>
                    <div className="iconos">
                        <a
                            href="https://wa.me/525643108583"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <span className="icono">
                                {/* WhatsApp */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-whatsapp" viewBox="0 0 16 16">
                                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                                </svg>
                            </span>
                        </a>

                        <a href="tel:+525588545539">
                            <span className="icono">
                                {/* Teléfono */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-phone-fill" viewBox="0 0 16 16">
                                    <path d="M3 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm6 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0" />
                                </svg>
                            </span>
                        </a>

                        <a
                            href="mailto:contacto@troqueladosmodulares.com.mx"
                            className="icono"
                            title="Enviar correo a contacto@troqueladosmodulares.com.mx"
                        >
                            {/* Correo */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-envelope-fill" viewBox="0 0 16 16">
                                <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
                            </svg>
                        </a>

                        <span className="icono">
                            {/* Ubicación */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                            </svg>
                        </span>
                    </div>
                </div>

                <nav className="navbar navbar-expand-lg custom-navbar">
                    <div className="container-fluid">
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav mx-auto">
                                <Link to={'/'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link active" href="#inicio">Inicio</a></li></Link>
                                <Link to={'/nosotros'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link" href="#nosotros">Nosotros</a></li></Link>
                                <Link to={'/servicios'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link" href="#servicios">Servicios</a></li></Link>
                                <Link to={'/certificaciones'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link">Certificaciones</a></li></Link>
                                <Link to={'/contacto'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link" href="#contacto">Contacto</a></li></Link>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>

            <div className='description'>
                <h2>NOSOTROS</h2>
                <br />
                <p>Somos una empresa 100% mexicana enfocada a la industria metal-mecánica ofreciendo soluciones
                    para el sector automotriz y de la cosntrucción, mediante la automatización de procesos, tecnología de
                    punta y talento especializado; ofreciendo productos de calidad con sistemas sustentables
                </p>
            </div>

            <div className="video-container">
                <img src={roseta} loading="lazy" className="logo-superpuesto" alt="Logo superior derecho" />
                <img src={roseta} loading="lazy" className="logo-inferior-izquierdo" alt="Logo inferior izquierdo" />
                <video
                    src={vidnosotros}
                    autoPlay
                    loop
                    muted
                    preload="none"
                    className="video-nosotros"
                    ref={videoRef}
                />
            </div>

            <footer className="footer">
                <div className="footer-top">
                    <p>55 8854 5539</p>
                </div>
                <div className="footer-content">
                    {/* Columna izquierda */}
                    <div className="footer-left">
                        <p>contacto@troqueladosmodulares.com.mx</p>
                        <p>Carretera México - Querétaro Km. 100, Jilotepec Edo. Méx.</p>
                        <img src={logo} loading="lazy" alt="Logo" className="footer-logo" />
                        <img src={esr} loading="lazy" alt="Logo" className="footer-logo" />
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                            <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '20px' }} width="50" height="50" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                            <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
                        </svg>
                    </div>

                    {/* Columna derecha */}
                    <div className="footer-right">
                        <p>  <a
                            href={aviso}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ cursor: "pointer", textDecoration: "none", color: "inherit" }}
                        >
                            Aviso de privacidad
                        </a></p>
                        <p>  <a
                            href={termino}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ cursor: "pointer", textDecoration: "none", color: "inherit" }}
                        >
                            Términos y Condiciones
                        </a></p>                        <p><a href="/contacto">Contáctanos</a></p>
                        <p>&copy; Troquelados modulares 2019</p>
                    </div>
                </div>
            </footer>

            <div style={{ height: '100%' }}></div>
        </div>
    );
};

export default Nosotros;